"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionRole = void 0;
/**
 * 权限角色
 */
var PermissionRole;
(function (PermissionRole) {
    PermissionRole["READER"] = "reader";
    PermissionRole["COMMENTER"] = "commenter";
    PermissionRole["WRITER"] = "writer";
    PermissionRole["EDITOR"] = "editor";
    PermissionRole["NONE"] = "none";
})(PermissionRole = exports.PermissionRole || (exports.PermissionRole = {}));
